import React from 'react';
import cx from 'classnames';
import HowItWorksSectionV2 from '@zola/zola-ui/src/components/PreAuth/HowItWorksSectionV2';

import shared from '~/styles/landingPageShared.module.less';
import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

import list from '../../content/howItWorksList';

type HowItWorksProps = {
  isNotLoggedIn: boolean;
};

const imageSm = `${process.env.ASSET_PATH}/static-preauth/images/CashGiftsLP/howItWorks/how@1x.png`;
const imageLg = `${process.env.ASSET_PATH}/static-preauth/images/CashGiftsLP/howItWorks/how@2x.png`;

/* ------------------------------------------------------------ */
const HowItWorks: React.FC<HowItWorksProps> = ({ isNotLoggedIn }) => {
  const ctaText = isNotLoggedIn ? 'Build Your Registry' : 'Add Cash Funds';
  const ctaLink = isNotLoggedIn ? '/onboard/new' : '/shop/honeymoon-cash-funds';
  const className = cx(shared.sectionContainer, css.howSection, shared.borderBottom);

  return (
    <div className={className}>
      <HowItWorksSectionV2
        howItWorksTitle="How It Works"
        howItWorksBackgroundColor="lightGray"
        largeImage={imageLg}
        smallImage={imageSm}
        howItWorksCTACopy={ctaText}
        howItWorksCTAUrl={ctaLink}
        numberedList={list}
      />
    </div>
  );
};

export default HowItWorks;
